(function () {
    'use strict';

    run.admin.managePaymentMethods = function () {
        const propertiesElement = document.getElementById('properties');
        var _stripe_key = propertiesElement.dataset.stripeKey;

        // Delete card
        let deleteCardButtons = document.querySelectorAll('.delete_card');
        if (deleteCardButtons !== null) {
            for (let i = 0; i < deleteCardButtons.length; i++) {
                deleteCardButtons[i].addEventListener("click", function(e) {
                    const el = e.target;
                    const _brand = el.dataset.brand;
                    const _last4 = el.dataset.last4;
                    const _location = el.dataset.href;

                    Swal.fire({
                        title: 'Please confirm this action',
                        html: `
                            <p>Are you sure that you want to remove your <strong>`+_brand+`</strong> ending with "<strong>`+_last4+`</strong>"?</p>
                        `,
                        showCloseButton: false,
                        showCancelButton: true,
                        showConfirmButton: true,
                        focusCancel: true,
                        cancelButtonText: 'Go back',
                        confirmButtonText: 'Remove card',
                        buttonsStyling: false,
                        reverseButtons: true,
                        customClass: {
                            cancelButton: 'btn btn-lg btn-light',
                            confirmButton: 'btn btn-lg btn-danger ms-4'
                        },
                        showClass: {
                            popup: 'animate__animated animated__fast animate__fadeInUp'
                        },
                        hideClass: {
                            popup: 'animate__animated animated__fast animate__fadeOutDown'
                        }
                    }).then((result) => {
                        if (result.value) {
                            window.location.href = _location;
                        }
                    });
                });
            }
        }

        // Make default card
        let makeDefaultCardButtons = document.querySelectorAll('.make_default');
        if (makeDefaultCardButtons !== null) {
            for (let i = 0; i < makeDefaultCardButtons.length; i++) {
                makeDefaultCardButtons[i].addEventListener("click", function(e) {
                    const el = e.target;
                    const _brand = el.dataset.brand;
                    const _last4 = el.dataset.last4;
                    const _location = el.dataset.href;

                    Swal.fire({
                        title: 'Please confirm this action',
                        html: `
                            <p>Are you sure that you want to make your <strong>`+_brand+`</strong> ending with "<strong>`+_last4+`</strong>" your default card?</p>
                        `,
                        showCloseButton: false,
                        showCancelButton: true,
                        showConfirmButton: true,
                        focusCancel: true,
                        cancelButtonText: 'Go back',
                        confirmButtonText: 'Make default',
                        buttonsStyling: false,
                        reverseButtons: true,
                        customClass: {
                            cancelButton: 'btn btn-lg btn-light',
                            confirmButton: 'btn btn-lg btn-primary ms-4'
                        },
                        showClass: {
                            popup: 'animate__animated animated__fast animate__fadeInUp'
                        },
                        hideClass: {
                            popup: 'animate__animated animated__fast animate__fadeOutDown'
                        }
                    }).then((result) => {
                        if (result.value) {
                            window.location.href = _location;
                        }
                    });
                });
            }
        }

        jQuery(document).ready(function() {



            var element =  document.getElementById('saved_cards');
            if (typeof(element) != 'undefined' && element != null) {
                new Splide( '#saved_cards', {
                    type   : 'loop',
                } ).mount();
            }

            // Stripe API Key
            var stripe = Stripe(_stripe_key);
            var elements = stripe.elements();
            // Custom Styling
            var style = {
                base: {
                    color: '#32325d',
                    lineHeight: '24px',
                    fontFamily: '"Open Sans", sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '16px',
                    '::placeholder': {
                        color: '#888'
                    }
                },
                invalid: {
                    color: '#fa755a',
                    iconColor: '#fa755a'
                }
            };

            // Create an instance of the card Element
            var card = elements.create('card', {style: style});

            // Add an instance of the card Element into the `card-element` <div>
            card.mount('#card-element');

            // Handle real-time validation errors from the card Element.
            card.addEventListener('change', function(event) {
                var displayError = document.getElementById('card-errors');

                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }
            });

            // Create a token when the form is submitted.
            var form = document.getElementById('change_payment_method');
            form.addEventListener('submit', function(e) {
                e.preventDefault();

                $('.btn-save').buttonLoadingState('loading');

                createToken();
            });

            function stripeTokenHandler(token) {
                // Insert the token ID into the form so it gets submitted to the server
                var form = document.getElementById('change_payment_method');
                $('input[name="stripeToken"]').attr('value', token.id);

                document.change_payment_method.submit();
            }

            function createToken() {
                stripe.createToken(card).then(function(result) {
                    if (result.error) {
                        // Inform the user if there was an error
                        var errorElement = document.getElementById('card-errors');
                        errorElement.textContent = result.error.message;
                        $('.btn-save').buttonLoadingState('reset');
                    } else {
                        // Send the token to your server
                        return stripeTokenHandler(result.token);
                    }
                });
            };            
        });
    }
})();
